// src/data/questions.js
    export const questions = [
    {
        id: 1,
        question: "드디어 기다리던 여행 한 달 전! 당신의 여행 계획 스타일은?",
        options: [
        { text: "엑셀이나 노션에 10분 단위로 동선 쫙! 맛집 리스트업은 기본이지.", type: "A" },
        { text: "항공권, 숙소 끝. '가서 끌리는 대로 하면 되지 뭐~' 무계획이 계획이다.", type: "B" }
        ]
    },
    {
        id: 2,
        question: "같이 가는 연인(또는 친구)과 여행 코스를 짤 때 당신의 반응은?",
        options: [
        { text: "이 핫플도 가고 저 야시장도 가야 해! 우리 잠은 죽어서 자자!", type: "A" },
        { text: "난 네가 좋은 곳이면 다 좋아. 하루에 한두 군데만 여유롭게 돌자.", type: "B" }
        ]
    },
    {
        id: 3,
        question: "출발 전날 밤, 캐리어를 펼친 당신.",
        options: [
        { text: "OOTD는 생명! 날짜별 룩북 세팅 완료. 고데기에 각종 영양제까지 바리바리 챙긴다.", type: "A" },
        { text: "지갑, 여권, 폰. 이 세 개면 어디든 갈 수 있어. 짐은 기내용으로 끝!", type: "B" }
        ]
    },
    {
        id: 4,
        question: "드디어 공항 가는 길! 차 안에서 당신은?",
        options: [
        { text: "최신 댄스곡 메들리 재생! 벌써 심장이 쿵쾅거리고 도파민이 솟구친다.", type: "A" },
        { text: "창밖 풍경 감상하며 잔잔한 인디 음악 재생. 차분하게 여행의 설렘을 즐긴다.", type: "B" }
        ]
    },
    {
        id: 5,
        question: "비행기 탑승 2시간 전, 남은 시간을 보내는 방법은?",
        options: [
        { text: "면세점은 못 참지! 향수부터 화장품까지 전 층을 빠른 걸음으로 싹 훑는다.", type: "A" },
        { text: "라운지나 조용한 게이트 앞 의자에서 커피 한 잔의 여유를 즐긴다.", type: "B" }
        ]
    },
    {
        id: 6,
        question: "비행기에 탑승했다. 당신의 이상적인 좌석은?",
        options: [
        { text: "당연히 복도석! 화장실 갈 때도 편하고, 착륙하자마자 1등으로 튀어나가야 함.", type: "A" },
        { text: "무조건 창가석! 구름 멍 때리고, 하늘 사진 백 장 찍는 게 비행의 묘미지.", type: "B" }
        ]
    },
    {
        id: 7,
        question: "기내식이 나왔다. 당신의 선택은?",
        options: [
        { text: "맥주나 와인 한 잔 곁들여서 야무지게 먹고, 영화 한 편 때려야지!", type: "A" },
        { text: "먹고 바로 양치 후 수면 안대 장착. 현지에서 놀 체력을 비축한다.", type: "B" }
        ]
    },
    {
        id: 8,
        question: "목적지 공항 도착! 게이트를 빠져나왔을 때 기분은?",
        options: [
        { text: "현지인들 사이에 섞여 있는 이 바이브! 당장 인스타 스토리부터 켠다.", type: "A" },
        { text: "낯선 공기 냄새 좋다... 심호흡 한 번 깊게 하고 천천히 짐 찾으러 간다.", type: "B" }
        ]
    },
    {
        id: 9,
        question: "숙소로 이동하는 길, 교통수단을 골라야 한다.",
        options: [
        { text: "복잡해도 현지 지하철이나 로컬 버스지! 사람 구경하는 재미가 쏠쏠하다.", type: "A" },
        { text: "돈 좀 쓰더라도 쾌적한 택시나 프라이빗 밴. 캐리어 끌고 땀 빼기 싫다.", type: "B" }
        ]
    },
    {
        id: 10,
        question: "숙소 체크인 완료! 방 문을 열고 들어가자마자 당신은?",
        options: [
        { text: "짐만 대충 던져두고 '자, 이제 어디부터 갈까?' 바로 나갈 채비를 한다.", type: "A" },
        { text: "침대에 대자로 뻗기. '아~ 좋다~' 30분 정도는 멍때리며 에너지를 충전한다.", type: "B" }
        ]
    },

    // 2. 여행 중 '낮'
    {
        id: 11,
        question: "여행 첫날 아침! 당신의 기상 시간은?",
        options: [
        { text: "아침 7시 기상! 조식 먹고 9시엔 무조건 숙소 밖으로 나가야지.", type: "A" },
        { text: "알람? 그게 뭐죠? 햇살이 얼굴을 비출 때 느지막이 일어난다.", type: "B" }
        ]
    },
    {
        id: 12,
        question: "제주도 같은 휴양지에 왔을 때, 당신이 선호하는 낮 일정은?",
        options: [
        { text: "요즘 틱톡에서 난리 난 오션뷰 대형 카페 갔다가, ATV 타러 가기!", type: "A" },
        { text: "새소리만 들리는 한적한 오름 하나 천천히 오르고 숲길 산책하기.", type: "B" }
        ]
    },
    {
        id: 13,
        question: "SNS에서 엄청 유명한 맛집 앞에 도착했는데 웨이팅이 2시간이다.",
        options: [
        { text: "이걸 먹으러 온 건데 당장 웨이팅 걸지! 근처 구경하다가 오면 됨.", type: "A" },
        { text: "2시간? 절대 못 해. 바로 옆 골목에 있는 사람 없는 한적한 식당으로 간다.", type: "B" }
        ]
    },
    {
        id: 14,
        question: "시내 관광 중, 다음 목적지까지 2km 정도 남았다.",
        options: [
        { text: "공유 자전거나 킥보드 빌려서 동네 골목골목 누비며 짜릿하게 이동!", type: "A" },
        { text: "풍경 보면서 슬슬 걸어가거나, 힘들면 무리 안 하고 바로 택시 호출.", type: "B" }
        ]
    },
    {
        id: 15,
        question: "광장에 도착했는데 갑자기 길거리 축제가 벌어지고 있다!",
        options: [
        { text: "완전 럭키! 카메라 켜고 인파 속으로 파고들어서 같이 리듬 탄다.", type: "A" },
        { text: "오, 신기하네. 멀찍이 계단에 앉아 구경만 하다가 조용히 빠져나온다.", type: "B" }
        ]
    },
    {
        id: 16,
        question: "여행지에서 당신의 사진첩 지분율은?",
        options: [
        { text: "내 사진 90%! 랜드마크 앞에서 점프샷, 인생샷 나올 때까지 수백 장 찍는다.", type: "A" },
        { text: "풍경 사진 90%. 아름다운 골목길, 길고양이, 예쁜 간판 위주로 남긴다.", type: "B" }
        ]
    },
    {
        id: 17,
        question: "기념품 샵에 들어갔다. 당신의 쇼핑 스타일은?",
        options: [
        { text: "친구들 나눠줄 거 한가득! 특이한 아이템 보면 눈 돌아가서 지갑 오픈.", type: "A" },
        { text: "나를 위한 엽서 한 장이나 마그넷 하나 정도만 소박하게 고른다.", type: "B" }
        ]
    },
    {
        id: 18,
        question: "오후 3시, 체력이 슬슬 떨어질 시간이다. 당신의 대처법은?",
        options: [
        { text: "당 충전 타임! 당도 100% 버블티나 젤라또 수혈하고 다시 텐션 업.", type: "A" },
        { text: "근처 조용한 공원 벤치를 찾거나 숙소로 잠시 돌아가 낮잠을 잔다.", type: "B" }
        ]
    },
    {
        id: 19,
        question: "걷다가 우연히 정말 맘에 드는 골목을 발견했다.",
        options: [
        { text: "이 골목 끝엔 뭐가 있을까? 호기심 폭발해서 끝까지 다 뒤져본다.", type: "A" },
        { text: "발걸음을 멈추고 골목의 정취를 온전히 느끼며 천천히 머문다.", type: "B" }
        ]
    },
    {
        id: 20,
        question: "액티비티를 해야 한다면 어떤 것을 고르겠는가?",
        options: [
        { text: "스릴 만점! 패러글라이딩, 서핑, 짚라인 등 익스트림 스포츠.", type: "A" },
        { text: "잔잔한 힐링~ 요가 클래스, 도자기 공방, 혹은 요트에서 선셋 보기.", type: "B" }
        ]
    },
    {
        id: 21,
        question: "미술관이나 박물관을 관람할 때 당신은?",
        options: [
        { text: "오디오 가이드 켜고 유명한 작품 위주로 싹 돌고 빠르게 인증샷 찰칵.", type: "A" },
        { text: "발길 닿는 대로 걷다가 마음에 꽂히는 그림 앞에서 한참을 서 있는다.", type: "B" }
        ]
    },
    {
        id: 22,
        question: "점심 식사 메뉴를 정할 때 당신의 방식은?",
        options: [
        { text: "구글 맵 리뷰 1000개 이상인 검증된 로컬 맛집으로 직진!", type: "A" },
        { text: "걷다가 분위기 좋아 보이고 사람 별로 없는 쾌적한 식당으로 들어간다.", type: "B" }
        ]
    },
    {
        id: 23,
        question: "카페에서 커피를 마시며 쉬고 있다. 당신의 행동은?",
        options: [
        { text: "다음 갈 곳 리뷰 찾고, 찍은 사진들 인스타에 실시간 폭풍 업로드!", type: "A" },
        { text: "창밖 지나가는 사람들 구경하거나 다이어리에 일기를 끄적인다.", type: "B" }
        ]
    },
    {
        id: 24,
        question: "날씨가 너무 덥다. 오후 일정을 어떻게 할까?",
        options: [
        { text: "더위가 대수냐! 땀 흘려도 텐션으로 극복. 대형 에어컨 있는 쇼핑몰로 우회.", type: "A" },
        { text: "무리하면 병난다. 해 질 때까지 숙소에서 샤워하고 에어컨 바람 쐬며 쉰다.", type: "B" }
        ]
    },
    {
        id: 25,
        question: "해가 뉘엿뉘엿 지고 있다. 낮 일정을 마무리하며 드는 생각은?",
        options: [
        { text: "아직 체력 남았어! 밤에는 또 어떤 재밌는 일이 기다릴까 기대된다.", type: "A" },
        { text: "오늘 하루도 무사히 잘 보냈다. 빨리 저녁 먹고 씻고 싶다.", type: "B" }
        ]
    },

    // 3. 여행 중 '밤'
    {
        id: 26,
        question: "드디어 여행지의 밤! 저녁 식사로 끌리는 분위기는?",
        options: [
        { text: "시끌벅적하고 활기찬 로컬 펍이나 음악 소리 빵빵한 라이브 바.", type: "A" },
        { text: "은은한 조명 아래, 일행과 조용히 대화 나눌 수 있는 오붓한 레스토랑.", type: "B" }
        ]
    },
    {
        id: 27,
        question: "타이베이 같은 도시에 왔다면 1일 1야시장은 필수! 야시장에 도착한 당신은?",
        options: [
        { text: "지파이, 곱창국수 다 내놔! 인파를 뚫고 먹거리 도장 깨기 시작.", type: "A" },
        { text: "사람 너무 많아서 기 빨린다... 입구에서 구경만 쓱 하고 빨리 숙소 가고 싶음.", type: "B" }
        ]
    },
    {
        id: 28,
        question: "연인(또는 친구)과 걷는 밤거리, 당신이 더 끌리는 분위기는?",
        options: [
        { text: "화려한 네온사인, 북적이는 사람들 속에서 느껴지는 도심의 불금 바이브.", type: "A" },
        { text: "인적 드문 골목길, 가로등 밑을 조용히 걸으며 듣는 풀벌레 소리.", type: "B" }
        ]
    },
    {
        id: 29,
        question: "숙소로 돌아가는 길에 편의점에 들렀다.",
        options: [
        { text: "숙소 2차 파티용 대용량 맥주와 새로운 현지 과자들 왕창 털어오기.", type: "A" },
        { text: "따뜻한 차 티백 하나랑 내일 아침에 먹을 요거트 정도만 소박하게 겟.", type: "B" }
        ]
    },
    {
        id: 30,
        question: "야경 명소에 도착했다. 당신의 감상법은?",
        options: [
        { text: "우와아악 대박! 인생샷 남기려고 100장 찍고 친구들이랑 영상통화 연결!", type: "A" },
        { text: "난간에 기대어 바람을 맞으며 묵묵히 도시의 불빛들을 감상한다.", type: "B" }
        ]
    },
    {
        id: 31,
        question: "여행지에서 우연히 한국인 동행 모임에 초대받았다면?",
        options: [
        { text: "오예 새로운 인연! 술자리 게임 주도하며 핵인싸 모드 온.", type: "A" },
        { text: "모르는 사람들이랑 텐션 맞추기 피곤해... 정중히 거절하고 내 시간을 갖는다.", type: "B" }
        ]
    },
    {
        id: 32,
        question: "밤 11시, 출출해진 당신. 어떡할까?",
        options: [
        { text: "근처 야식 맛집 폭풍 검색! 슬리퍼 끌고 무조건 밖으로 나간다.", type: "A" },
        { text: "나가기 귀찮다. 아까 사 둔 컵라면에 물 붓거나 그냥 참는다.", type: "B" }
        ]
    },
    {
        id: 33,
        question: "숙소에서 반신욕을 마쳤다. 잠들기 전 루틴은?",
        options: [
        { text: "침대에 누워 오늘 찍은 사진 폭풍 보정 + 내일 갈 핫플 릴스 탐방.", type: "A" },
        { text: "조명 낮추고 블루투스 스피커로 잔잔한 음악 틀어놓고 꿀잠 준비.", type: "B" }
        ]
    },
    {
        id: 34,
        question: "창밖에서 희미하게 버스킹 노래가 들려온다.",
        options: [
        { text: "어? 무슨 노래지? 당장 창문 열거나 가운 걸치고 테라스로 뛰쳐나간다.", type: "A" },
        { text: "음악 소리 좋네... BGM 삼아 눈을 감고 분위기에 취해본다.", type: "B" }
        ]
    },
    {
        id: 35,
        question: "친구(연인)가 피곤하다며 곯아떨어졌다. 아직 안 졸린 당신은?",
        options: [
        { text: "심심해! 혼자라도 로비나 근처 바에 나가서 칵테일 한 잔 마시고 온다.", type: "A" },
        { text: "오히려 좋아. 나만의 온전한 혼자만의 시간을 가지며 책이나 넷플릭스를 본다.", type: "B" }
        ]
    },
    {
        id: 36,
        question: "만약 숙소가 엄청난 번화가 한가운데 있다면?",
        options: [
        { text: "창문 밖으로 클럽 노래 들림! 방 안에서도 둠칫둠칫 텐션 올라감.", type: "A" },
        { text: "방음 최악... 귀마개 꽂고 다음부턴 무조건 숲속 숙소 잡아야지 다짐함.", type: "B" }
        ]
    },
    {
        id: 37,
        question: "별을 보러 외곽으로 나갔다. 당신의 반응은?",
        options: [
        { text: "별자리 어플 켜서 별 이름 다 찾아보고 아이폰 야간모드로 촬영 시도!", type: "A" },
        { text: "돗자리 깔고 누워서 쏟아지는 별을 보며 조용히 생각에 잠긴다.", type: "B" }
        ]
    },
    {
        id: 38,
        question: "여행 중 가장 좋아하는 밤의 시간대는?",
        options: [
        { text: "저녁 8시~11시! 화려한 조명 속에서 본격적으로 놀기 시작하는 골든 타임.", type: "A" },
        { text: "새벽 1시~2시. 모두가 잠든 고요한 시간, 세상에 나 혼자 있는 듯한 기분.", type: "B" }
        ]
    },
    {
        id: 39,
        question: "내일 아침 일찍 투어가 예약되어 있는데, 지금 새벽 1시다.",
        options: [
        { text: "놀러 왔는데 잠이 오냐! 투어 버스에서 자면 되니까 더 놀다 잔다.", type: "A" },
        { text: "내일 지각하면 안 돼. 서둘러 알람 3개 맞추고 바로 강제 취침.", type: "B" }
        ]
    },
    {
        id: 40,
        question: "마지막 날 밤이다. 당신의 심정은?",
        options: [
        { text: "마지막 1초까지 불태워야 해! 제일 좋은 라운지 바 가서 양주 깐다.", type: "A" },
        { text: "짐 미리 다 싸놓고, 캐리어 닫아둔 채 지난 며칠을 돌아보며 아쉬워한다.", type: "B" }
        ]
    },

    // 4. 돌발 상황 & 여행 후
    {
        id: 41,
        question: "외출 준비 다 했는데 창밖으로 폭우가 쏟아진다!",
        options: [
        { text: "오히려 스펙타클해! 우비 입고 비 맞으며 뛰노는 청춘 영화 찍는다.", type: "A" },
        { text: "오늘 일정 전면 취소. 숙소에서 빗소리 들으며 파전이나 배달시킬까?", type: "B" }
        ]
    },
    {
        id: 42,
        question: "휴대폰 배터리가 3%다! 길 한복판에서 당신은?",
        options: [
        { text: "가게 들어가서 '익스큐즈미 충전 플리즈!' 바디랭귀지로 넉살 좋게 해결.", type: "A" },
        { text: "일단 침착하게 눈에 띄는 벤치나 스타벅스에 들어가서 멘탈부터 잡는다.", type: "B" }
        ]
    },
    {
        id: 43,
        question: "열심히 찾아간 맛집, 음식 맛이 최악이다.",
        options: [
        { text: "이것도 추억이지! '절대 가지 마시오' 사진 찍어서 단톡방에 올리며 웃는다.", type: "A" },
        { text: "내 소중한 한 끼가... 조용히 남기고 나와서 근처 디저트 가게로 위로받으러 간다.", type: "B" }
        ]
    },
    {
        id: 44,
        question: "비행기 연착으로 공항에서 3시간을 버텨야 한다면?",
        options: [
        { text: "공항 구석구석 탐험하고 면세점 한 바퀴 더 돌면서 시간 알차게 죽이기.", type: "A" },
        { text: "의자 3개 차지하고 누워서 헤드폰 끼고 본격적인 노숙 모드 돌입.", type: "B" }
        ]
    },
    {
        id: 45,
        question: "한국으로 돌아오는 비행기 안, 무슨 생각을 하나?",
        options: [
        { text: "다음 연휴가 언제더라? 달력 앱 켜서 다음 여행지 티켓 미리 검색 중.", type: "A" },
        { text: "드디어 집에 간다! 빨리 내 방 침대에 눕고 배달 떡볶이 시켜 먹고 싶다.", type: "B" }
        ]
    },
    {
        id: 46,
        question: "집에 도착했다. 짐 정리는 언제?",
        options: [
        { text: "나중에 시간 날 때 대충~ 일단 친구들 만나서 여행 썰부터 풀러 나간다.", type: "A" },
        { text: "오자마자 캐리어 싹 비우고 빨래통에 넣어야 마음이 편해서 직성이 풀린다.", type: "B" }
        ]
    },
    {
        id: 47,
        question: "이번 여행의 여독을 푸는 당신만의 방법은?",
        options: [
        { text: "사람들 만나서 여행 사진 보여주며 수다 떨면 도파민 돌아서 피로 회복!", type: "A" },
        { text: "주말 내내 집 밖으로 한 발짝도 안 나가고 이불 속에서 칩거하기.", type: "B" }
        ]
    },
    {
        id: 48,
        question: "사진첩에 쌓인 2천 장의 여행 사진.",
        options: [
        { text: "일단 A컷 10장 골라서 인스타 피드 박제! 친구들 태그는 필수.", type: "A" },
        { text: "천천히 넘겨 보면서 나만 아는 풍경 사진을 폰 배경화면으로 조용히 바꾼다.", type: "B" }
        ]
    },
    {
        id: 49,
        question: "친구가 '이번 여행 어땠어?'라고 물어본다면?",
        options: [
        { text: "야 진짜 미쳤어!! 개꿀잼!! 에피소드가 한 트럭인데 밥 먹으면서 다 말해줌!!", type: "A" },
        { text: "응, 진짜 푹 쉬다 왔어. 동네가 조용해서 너무 좋더라. 완전 힐링했지.", type: "B" }
        ]
    },
    {
        id: 50,
        question: "당신에게 '좋은 여행'이란 무엇인가?",
        options: [
        { text: "새로운 사람, 낯선 자극! 1분 1초도 지루할 틈 없이 도파민이 터지는 모험!", type: "A" },
        { text: "일상의 스위치를 끄고, 복잡한 생각 없이 온전히 나만의 속도에 집중하는 시간.", type: "B" }
        ]
    }
    ];